// src/components/TelefonoInput.js
//
// Entrada de telefono con prefijo de pais que compone el E.164 que espera el
// backend. El login dejo de ser por correo cuando el backend paso a
// LoginRequestDto { Telefono (E.164), Password }, y el web se quedo atras
// mandando { correo, password }: devolvia 400 siempre.
//
// El backend normaliza y valida con TelefonoE164, asi que aqui basta con
// componer "+<indicativo><numero>" y limpiar lo que no sea digito.

import React from 'react';
import { Box, MenuItem, TextField } from '@mui/material';

// Colombia primero porque es donde opera el piloto. La lista es corta a
// proposito: se amplia cuando haga falta, no antes.
export const PAISES = [
  { codigo: 'CO', indicativo: '57', nombre: 'Colombia',      largo: 10 },
  { codigo: 'MX', indicativo: '52', nombre: 'México',        largo: 10 },
  { codigo: 'PE', indicativo: '51', nombre: 'Perú',          largo: 9  },
  { codigo: 'EC', indicativo: '593', nombre: 'Ecuador',      largo: 9  },
  { codigo: 'US', indicativo: '1',  nombre: 'Estados Unidos', largo: 10 },
  { codigo: 'ES', indicativo: '34', nombre: 'España',        largo: 9  },
];

export const soloDigitos = (s) => (s || '').replace(/\D/g, '');

/** Compone el E.164 a partir del indicativo y el numero local. */
export function componerE164(indicativo, numero) {
  const n = soloDigitos(numero);
  if (!n) return '';
  return `+${indicativo}${n}`;
}

/** Un E.164 valido para nuestro caso: + y entre 8 y 15 digitos. */
export function esE164Valido(e164) {
  return /^\+\d{8,15}$/.test(e164 || '');
}

export default function TelefonoInput({
  indicativo,
  numero,
  onChange,          // (indicativo, numero, e164, valido)
  label = 'Teléfono',
  error,
  helperText,
  autoFocus = false,
  disabled = false,
}) {
  const pais = PAISES.find((p) => p.indicativo === indicativo) || PAISES[0];

  const emitir = (nuevoInd, nuevoNum) => {
    const e164 = componerE164(nuevoInd, nuevoNum);
    onChange(nuevoInd, nuevoNum, e164, esE164Valido(e164));
  };

  return (
    <Box sx={{ display: 'flex', gap: 1.25, alignItems: 'flex-start' }}>
      <TextField
        select
        label="País"
        value={pais.indicativo}
        onChange={(e) => emitir(e.target.value, numero)}
        disabled={disabled}
        sx={{ width: 132, flexShrink: 0 }}
      >
        {PAISES.map((p) => (
          <MenuItem key={p.codigo} value={p.indicativo}>
            {p.codigo} +{p.indicativo}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        label={label}
        value={numero}
        onChange={(e) => emitir(pais.indicativo, soloDigitos(e.target.value))}
        error={!!error}
        helperText={error || helperText}
        autoFocus={autoFocus}
        disabled={disabled}
        fullWidth
        inputProps={{ inputMode: 'numeric', maxLength: 15 }}
        placeholder={pais.codigo === 'CO' ? '3105655987' : ''}
      />
    </Box>
  );
}
